import { Button, CircularProgress } from "@mui/joy";
import { SxProps } from "@mui/material";
import React, { MouseEventHandler } from "react";

interface WrappedButtonProps {
	busy?: boolean;
	disabled?: boolean;
	sx?: SxProps | undefined;
	onClick: MouseEventHandler<HTMLAnchorElement>;
	children: any;
	color?: "primary" | "neutral" | "danger" | "success" | "warning";
	variant?: "solid" | "soft" | "outlined" | "plain";
	startDecorator?: React.ReactNode;
}
export default function WrappedButton(props: WrappedButtonProps) {
	return (
		<Button onClick={props.onClick} disabled={props.busy || props.disabled} color={props.color} variant={props.variant} sx={props.sx} startDecorator={props.startDecorator}>
			{props.busy && <CircularProgress sx={{ mr: 1 }} />}
			{props.children}
		</Button>
	);
}
